import * as React from 'react';
import { submitAddArticleComment, resetData } from 'modules/magazine/article/addarticlecomment';
import { IArticleComment } from 'models/magazine/article/articlecomment';
import { reduxForm, InjectedFormProps, Field } from 'redux-form';
import { IAddArticleComment, IAddArticleCommentAction } from 'models/magazine/article/addarticlecomment';
import { PortalTextareaField } from 'components/FormControls';
import { CoverPicture } from 'components/Profile/CoverPicture';
import { IUserPreferences } from 'models/user/userpreferences';
import { thumbUrl } from 'helpers/common';
import * as c from 'models/constants';
import { IArticleCommentBox } from 'models/common';
import { useOutsideAlerter } from 'components/Magazine/Article/ArticleComment/ArticleComment';
import { maxLength } from 'helpers/validationattributes';
const { connect } = require('react-redux');

interface IProps extends InjectedFormProps {
	// sent from parent
	articleId: string;

	handleSubmit?: any;
	addArticleComment?: IAddArticleComment;
	userPreferences: IUserPreferences;
	currentFormValues?: IArticleCommentBox;
	onNewCommentAdded: (comment: IArticleComment) => void;
	submitAddArticleComment?: (comment: IArticleComment) => IAddArticleCommentAction;
	resetData?: () => IAddArticleCommentAction;
	t: (key: string) => string;
	parentComment?: string;
	inputRef?: React.RefObject<HTMLInputElement>;
}

const loggedIn = (currentUserId) => (currentUserId ? undefined : { _error: 'You must be logged in to add a comment' });

const maxLength500 = maxLength(500);

const AddArticleCommentForm = (props: IProps) => {
	const [rows, setRows] = React.useState(false);
	const addCommentFormRef = React.useRef<HTMLFormElement>(null);
	useOutsideAlerter(addCommentFormRef, setRows, false);
	const articleComment: IArticleComment = { body: '', addedByEmail: '' };

	const { userPreferences, t, resetData, submitAddArticleComment, articleId, addArticleComment, parentComment } = props;

	const currentUserId = userPreferences?.id;

	React.useEffect(() => {
		// similar to componentDidMount and componentDidUpdate
		if (addArticleComment?.newCommentAdded) {
			resetData();
		}
	}, []);

	const onSubmit = (form: IAddArticleComment) => {
		// construct comment object
		if (currentUserId) {
			articleComment.addedByEmail = userPreferences.email;
		}

		articleComment.body = parentComment ? form.articleCommentReply.body : form.articleComment.body; // if parentComment is set, then we are replying to a comment
		articleComment.articleId = articleId; // changed from articleComment.parentId to articleComment.articleId (BE update)
		// articleComment.parentId = articleId
		articleComment.addedById = currentUserId;
		// articleComment.data = parentComment ? parentComment : null;   till the 4.4.2023 backend update,
		articleComment.parentId = parentComment ? parentComment : null; // after the 4.4.2023 backend update  // TODO: Test this
		articleComment.reviewed = true; // what is the reviewed field for?

		submitAddArticleComment(articleComment);

		// Reset comment field
		props.currentFormValues.articleCommentReply
			? (props.currentFormValues.articleCommentReply.body = '')
			: (props.currentFormValues.articleComment.body = '');
	};

	const onEnterPress = (e) => {
		// On enter listener for the comment box
		if (e.keyCode == 13 && e.shiftKey == false) {
			e.preventDefault();
			if (e.target.value.length > 0) {
				addCommentFormRef.current.requestSubmit();
			}
		}
	};

	return userPreferences?.id ? ( // if user is logged in, show the comment box
		<form
			onSubmit={props.handleSubmit(onSubmit)}
			className="review-box d-flex flex-row align-items-start flex-wrap"
			autoComplete="off"
			ref={addCommentFormRef}
		>
			<div className="photo-container d-flex align-items-center justify-content-center">
				<CoverPicture
					imageUrl={userPreferences?.profilePicture ? thumbUrl(userPreferences.profilePicture, 'small') : ''}
					// hasPicture={Boolean(picture)}
					editFunction={null}
				/>
			</div>
			<div className={`field-container`}>
				<Field
					name={parentComment ? 'articleCommentReply.body' : 'articleComment.body'} // if it has parent comment id, then it is a reply
					component={PortalTextareaField}
					{...{ customRef: props.inputRef }}
					label={t('AddComment_Input_Placeholder')}
					validate={[loggedIn, maxLength500]}
					rows={rows ? 3 : 1}
					height={'auto'}
					onFocusAction={() => setRows(true)}
					disablePaddingOnFocus={true}
					iconName="arrowBlack"
					iconClassName="commentIcon"
					customIconSizeWidth={16}
					customIconSizeHeight={16}
					submitOnIconClick={true}
					disableMargin={true}
					onKeyDownAction={onEnterPress}
				/>
			</div>
		</form>
	) : (
		''
	);
};

const mapStateToProps = (state) => {
	let currentFormValues: IArticleCommentBox = null;
	if (state.form[c.FORM_NAME_ADD_COMMENT] && state.form[c.FORM_NAME_ADD_COMMENT].values) {
		currentFormValues = state.form[c.FORM_NAME_ADD_COMMENT].values;
	}

	return {
		initalValues: state.addArticleComment,
		addArticleComment: state.addArticleComment,
		userPreferences: state.userPreferences,
		currentFormValues,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitAddArticleComment: (comment: IArticleComment) => dispatch(submitAddArticleComment(comment)),
		resetData: () => dispatch(resetData()),
	};
};

let AddArticleComment = reduxForm({
	form: c.FORM_NAME_ADD_COMMENT,
	enableReinitialize: true,
})(AddArticleCommentForm);

AddArticleComment = connect(mapStateToProps, mapDispatchToProps)(AddArticleComment);

export default AddArticleComment;
